export enum BeamWidth {
	Narrow = 'NARROW',
	Medium = 'MEDIUM',
	Wide = 'WIDE'
}
